import CreateProductChange from './CreateProductChange';

export default CreateProductChange;
